/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'cash': 'Barzahlung',
    'credit_card': 'Kreditkarte',
    'direct_debit': 'Lastschrift',
    'wire_transfer': 'Überweisung'
  },

  /* english */
  en: {
    'cash': 'Cash',
    'credit_card': 'Credit Card',
    'direct_debit': 'Direct debit',
    'wire_transfer': 'Wire transfer'
  }
}
